import React, { useEffect } from 'react';
import DirectReferrals from '../components/team/DirectReferrals';
import LevelStructure from '../components/team/LevelStructure';
import { useUI } from '../contexts/UIContext';
import { useWeb3 } from '../contexts/Web3Context';

const Team = () => {
  const { teamTab, setTeamTab, currentLevel } = useUI();
  const { userId, isConnected } = useWeb3();

  // If no user ID, show message to connect or invest
  if (!isConnected || !userId || userId === 0) {
    return (
      <>
        <h1>Your <span className="highlight">Team</span> Network</h1>
        <p className="section-description">Track your referrals and team performance</p>
        
        <div className="not-connected-message" style={{ 
          textAlign: 'center', 
          background: 'var(--bg-card)', 
          padding: '50px 20px',
          borderRadius: '15px',
          margin: '40px 0'
        }}>
          <h2>{isConnected ? 'Make Your First Investment' : 'Connect Your Wallet'}</h2>
          <p style={{ marginTop: '15px', color: 'var(--text-muted)' }}>
            {isConnected 
              ? 'You need to make your first investment to access your team network.'
              : 'Connect your wallet to view your team network.'}
          </p>
        </div>
      </>
    );
  }

  // Switch between team tabs
  const handleTabChange = (tab) => {
    setTeamTab(tab);
  };

  return (
    <>
      <h1>Your <span className="highlight">Team</span> Network</h1>
      <p className="section-description">Track your referrals and team performance</p>
      
      <div className="team-tabs">
        <div className="tab-selector">
          <button 
            className={`team-tab ${teamTab === 'direct' ? 'active' : ''}`} 
            onClick={() => handleTabChange('direct')}
          >
            Direct Referrals
          </button>
          <button 
            className={`team-tab ${teamTab === 'levels' ? 'active' : ''}`}
            onClick={() => handleTabChange('levels')}
          >
            Level Structure
          </button>
        </div>
        
        {/* Tab content */}
        {teamTab === 'direct' ? (
          <DirectReferrals />
        ) : (
          <LevelStructure />
        )}
      </div>
    </>
  );
};

export default Team;
